import React, { Suspense, lazy } from 'react';
import styled from '@emotion/styled';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Header from './components/Layout/Header';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import GlobalStyles from './styles/GlobalStyles';
import AdminDashboardPage from './pages/Admin/AdminDashboardPage';

const ChatPage = lazy(() => import('./components/Chat/ChatPage'));

// Komponenta za preusmeritev na korenu (/)
const RootRedirect = () => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <Navigate to="/chat" replace /> : <Navigate to="/login" replace />;
};

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  width: 100%;
  overflow-x: hidden;
  background:
    radial-gradient(circle at top right, rgba(99, 102, 241, 0.25), transparent 45%),
    radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.15), transparent 40%),
    linear-gradient(180deg, rgba(240, 242, 255, 0.7) 0%, rgba(247, 250, 255, 0.95) 100%);
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

function App() {
  return (
    <Router>
      <GlobalStyles /> {/* Add GlobalStyles component here */}
      {/* UPORABITE AppContainer TUKAJ */}
      <AppContainer>
        <Header />
        {/* UPORABITE MainContent TUKAJ */}
        <MainContent>
          <Suspense fallback={<div className="fallback">Loading...</div>}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/chat"
                element={
                  <ProtectedRoute>
                    <ChatPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<RootRedirect />} />
            </Routes>
          </Suspense>
        </MainContent>
      </AppContainer>
      <Toaster />
    </Router>
  );
}

export default App;
